const phoneErrorRegex = /^Phone No.*already in use.*/;

export const isPhoneUpdateError = (error: string) => {
    return phoneErrorRegex.test(error);
};

export const isUpdateRetryError = (error: string) => {
    return error.includes('GetAllExtendedMemberData failed to get data');
};
